import { Type } from 'lucide-react';
import { FilterStringConfig } from 'v5/patterns/filters/FilterWidget.types';

export function createProductionTitleFilterConfig(): FilterStringConfig {
  return {
    label: 'Title',
    icon: <Type />,
    type: 'string',
    createDefaultValue: () => ({ operator: 'contains', value: '' })
  };
}
